import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { NgOptimizedImage } from '@angular/common';
import { UmmeldungStore } from '../../ummeldung.store';
import { WIZARD_CONTROLLER } from '@mwe/features/wizard';
import { injectUmmeldungDraftSaver } from '../../utils';

@Component({
  selector: 'ikp-save-and-close-ummeldung-button',
  imports: [TranslatePipe, NgOptimizedImage],
  templateUrl: './save-and-close-button-ummeldung-wizard.component.html',
  styleUrl: './save-and-close-button-ummeldung-wizard.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SaveAndCloseButtonUmmeldungWizardComponent {
  private readonly ummeldungStore = inject(UmmeldungStore);
  private readonly wizardController = inject(WIZARD_CONTROLLER);
  private readonly saveDraft = injectUmmeldungDraftSaver();

  protected readonly isLoading = computed(() => this.ummeldungStore.loading());

  onClick(): void {
    this.saveDraft()?.subscribe(() => this.wizardController.close('finished'));
  }
}
